import { useMemo, useState } from "react";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

export function onlyAlphabets(data) {
    try {
        let value = data;
        value = value.replace(/[^a-z\s]/gi, '')
        return value;
    }
    catch (error) {
        return error;
    }
}

export function onlyAlphabetswithnospace(data) {
    try {
        let value = data;
        value = value.replace(/[^a-z]/gi, '');
        return value;
    } catch (error) {
        return error;
    }
}

export function onlyNumeric(numdata) {
    try {
        let numvalue = numdata;
        numvalue = numvalue.replace(/[^0-9]/g, '');
        return numvalue;
    }
    catch (error) {
        return error;
    }
}

export function onlyNumericwithminus(numdata) {
    try {
        let numvalue = numdata;
        numvalue = numvalue.replace(/[^0-9-]/g, '');
        return numvalue;
    }
    catch (error) {
        return error;
    }
}

export function alphaNumeric(data) {
    try {
        let numvalue = data;
        numvalue = numvalue.replace(/[^A-Za-z0-9]/g, '')
        return numvalue;
    }
    catch (error) {
        return error;
    }
}

export function alphaNumericspace(data) {
    try {
        let numvalue = data;
        numvalue = numvalue.replace(/[^A-Za-z0-9 ]/g, '')
        return numvalue;
    }
    catch (error) {
        return error;
    }
}

export function alphaSpace(data) {
    try {
        let numvalue = data;
        numvalue = numvalue.replace(/[^A-Za-z ]/g, '')
        return numvalue;
    }
    catch (error) {
        return error;
    }
}

export function PhoneNmber(num) {
    try {
        let numvalue = num;
        numvalue = numvalue.replace(/[^0-9\+\-\(\)]/, '')
        return numvalue;
    }
    catch (error) {
        return error;
    }
}

export function normalizeInput(value, previousValue) {
    if (!value) return value;
    const currentValue = value.replace(/[^\d]/g, '');
    const cvLength = currentValue.length;

    if (!previousValue || value.length > previousValue.length) {
        if (cvLength < 4) return currentValue;
        if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
    }
}

export function NumericWithDecimal(num) {
    try {
        let numvalue = num;
        numvalue = numvalue.replace(/[^0-9\.]/, '')
        return numvalue;
    }
    catch (error) {
        return error;
    }
}

export function isValidEmail(email) {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(email);
}

export function isValidPhonenumber(num) {
    return /^[\d\(\)\-+]+$/m.test(num);
};

export function validateURL(URL) {
    return /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm.test(URL)
}

export const isEmpty = (value) => !value || value?.trim()?.length === 0;

export function isValidURL(data) {
    const urlRegex = new RegExp(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    return urlRegex?.test(data);
}

export function getDateCombination(fileName) {
    const today = new Date();
    const date = today.getFullYear().toString() + (today.getMonth() + 1).toString() + today.getDate().toString();
    const time = today.getHours().toString() + (today.getMinutes() + 1).toString() + today.getSeconds().toString();
    const filename = (fileName?.replace(/ /g, "_"))?.replace(/-/g, '')
    return `${date}_${time}_1_${filename}`;
}

export function useSortableData(items, config = null) {
    const [sortConfig, setSortConfig] = useState(config);
    const sortedItems = useMemo(() => {
        let sortableItems = [...items];
        if (sortConfig !== null) {
            sortableItems.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableItems;
    }, [items, sortConfig]);

    const requestSort = (key, dir) => {
        let direction = dir;
        setSortConfig({ key, direction });
    };
    return { items: sortedItems, requestSort, sortConfig };
}

export function generatePDF(columns, rows, filename, filetitle, orientationtype = "p") {
    const pdf = new jsPDF(orientationtype, "pt", "a4");
    let textX = (pdf.internal.pageSize.getWidth() - pdf.getTextWidth(filetitle)) / 2

    pdf.text(filetitle, textX, 40);
    pdf.autoTable(columns, rows, {
        startY: 65,
        theme: "grid",
        styles: {
            font: "times",
            minCellWidth: 33,
            cellPadding: 3.5,
            lineWidth: 0.5,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0]
        },
        headStyles: {
            textColor: [0, 0, 0],
            halign: "center",
            fontStyle: "bold",
            lineWidth: 0.5,
            lineColor: [0, 0, 0],
            fillColor: [166, 204, 247]
        },
        alternateRowStyles: {
            fillColor: [212, 212, 212],
            textColor: [0, 0, 0],
            lineWidth: 0.5,
            lineColor: [0, 0, 0]
        },
        rowStyles: {
            lineWidth: 0.5,
            lineColor: [0, 0, 0]
        },
        tableLineColor: [0, 0, 0]
    });
    pdf.save(filename);
}

export function isImageValidPng(FileName) {
    return /\.(png)$/i.test(FileName)
}

export function isValidVideo(DocName) {
    return /\.(mov|mp4|mp3|wmv|avi)$/i.test(DocName)
}

export function isNoSpecialCharacter(strvalue) {
    return /^[A-Za-z0-9 ]+$/.test(strvalue)
}

export function numberAndSpecialCharacter(value) {
    const regex = /^[0-9 °'"`@#$%^&.*+?^_`{|}~-]*$/;

    const inputIsValid = regex.test(value);
    return inputIsValid
}

export function onlyNumbersAndSpacialCharacters(str) {
    try {
        let value = str;
        value = value.replace(/[^0-9@~`!@#$%^&*()_=+{}[|';:\]"\\/?>.<,-\s]/g, '')
        return value;
    }
    catch (error) {
        return error;
    }
}

export const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today?.getFullYear() - birthDate?.getFullYear();
    const monthDiff = today?.getMonth() - birthDate?.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today?.getDate() < birthDate?.getDate())) {
        age--;
    }

    return age;
};

export function getHTMLContentWordLength(htmlString = "") {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    const words = tempDiv?.innerText?.split(" ")?.filter((fil) => fil !== "" && fil !== "\n" && fil !== "-")
    return words?.length;
}

export function getHTMLContentCharacterLength(htmlString = "") {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    return tempDiv.innerText.length;
}

export function getDecodedHTMLRawLength(htmlString = "") {
    let text = htmlString
        .replace(/<\/(p|div|br)\s*>/gi, "\n") // preserve block breaks
        .replace(/<[^>]*>/g, "");             // strip other tags

    // Decode HTML entities
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = text;
    text = tempDiv.textContent || text;
    return text.length;
}

export const isBlank = [null, ""];
export const isNullable = ["", null, undefined];
export const isNullableWithZero = ["", null, undefined, 0];

export function formatDate(date) {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return date ? [day, month, year].join('/') : null;
}

export function formatDateyearmonthday(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return date === null ? null : [year, month, day].join('-');
}

export function formatTimeHourMinute(time) {
    let x = new Date(time)
    let hours = x.getHours();
    let minut = x.getMinutes();
    if (hours < 10) {
        hours = '0' + hours
    }
    if (minut < 10) {
        minut = '0' + minut
    }
    return time === null ? '' : [hours, minut].join(':');
}

export function HourMinuteFromOnlyTime(time) {
    // time = "10:13:25" or "10:13:00" => Output "10:13"
    const [hour, minute, second] = time?.split(":");
    const returnTime = `${hour}:${minute}`;
    return time === null ? '' : returnTime
}

export function TimeHour(time) {
    let x = new Date(time)
    let hours = x.getHours();
    if (hours < 10) {
        hours = '0' + hours
    }
    return time === null ? '' : hours;
}

export function formatJsonDateToSQL(dateInput) {
    const date = new Date(dateInput);

    // Pad with zero if needed
    const pad = (n) => n.toString().padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Month is zero-based
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

export const getTimeInSeconds = (dateStr) => {
    const date = new Date(dateStr);
    return (
        date.getHours() * 3600 +
        date.getMinutes() * 60 +
        date.getSeconds()
    );
};

export const getTodayAtMidnight = () => {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}T00:00:00`;
};

export function formatOnlyTimeToSQL(dateInput) {
    const date = new Date(dateInput);

    // Pad with zero if needed
    const pad = (n) => n.toString().padStart(2, '0');

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${hours}:${minutes}:${seconds}`;
}

export function dateFormatWithTime(date = new Date(), time) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return `${year}-${month}-${day}T${time}`;
}

export function VehicleCategoryRegex(data) {
    try {
        let value = data;
        value = value?.replace(/[^A-Za-z\s.-]+/, '')
        return value;
    }
    catch (error) {
        return error;
    }
}

export function vehicleNameRegex(data) {
    try {
        let value = data;
        value = value?.replace(/[^A-Za-z0-9 ]+/g, '');
        value = value?.slice(0, 25);
        return value;
    }
    catch (error) {
        return error;
    }
}